"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebugDependencies = void 0;
const react_1 = require("react");
const useDebugDependencies = (dependencies) => {
    const firstRender = (0, react_1.useRef)(true);
    const prevDeps = (0, react_1.useRef)(dependencies);
    (0, react_1.useEffect)(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        const changedDeps = dependencies
            .map((dep, i) => {
            if (dep !== prevDeps.current[i]) {
                return i;
            }
            return null;
        })
            .filter((dep) => dep !== null);
        if (changedDeps.length > 0) {
            console.log('Changed dependencies:', changedDeps);
        }
        prevDeps.current = dependencies;
    }, dependencies);
};
exports.useDebugDependencies = useDebugDependencies;
